<div class="dash-card">
    <div class="row dash-card-header" *ngIf="!loading">
        <ng-container *ngIf="data">
            <div class="col-8 d-flex align-items-center">
                <h2>{{data.group}}</h2>
                <app-spacer [right]="16"></app-spacer>

                <svg-icon src="assets/images/icon-check-filled.svg"
                    fill="var(--success)"
                    *ngIf="data.status === 'Ativo'"></svg-icon>
                <svg-icon src="assets/images/icon-ban.svg" fill="var(--danger)"
                    *ngIf="data.status === 'Inativo'"></svg-icon>
                <app-spacer [right]="8"></app-spacer>
                {{data.status === 'Ativo' ? 'Ativo' : 'Inativo'}}
            </div>
            <div class="col-4 text-right">
                <app-button (onClick)="toggleStatus()"
                    [danger]="data.status === 'Ativo'"
                    *ngIf="permissionObj.canAdd">
                    {{data.status === 'Ativo' ? 'Inativar grupo' :'Ativar
                    grupo'}}
                </app-button>
            </div>
        </ng-container>
    </div>
</div>
<app-spacer [bottom]="48"></app-spacer>


<ng-container *ngIf="permissionObj.canView">
    <div class="dash-card no-padding">
        <div class="dash-card-header d-block" style="flex-direction: column;">
            <div class="row no-gutters">
                <div class="col-12">
                    <div>
                        <h2>Usuários</h2>
                    </div>
                </div>
            </div>

            <div class="row no-gutters">
                <div class="col-12 d-flex justify-content-end mt-3 px-0">
                    <ng-container *ngIf="usersLoading">
                        <ngx-skeleton-loader [theme]="{
                            width: '120px',
                            height: '40px',
                            marginRight: '8px'
                          }">
                        </ngx-skeleton-loader>
                        <ngx-skeleton-loader [theme]="{
                            width: '120px',
                            height: '40px',
                            marginRight: '8px'
                          }">
                        </ngx-skeleton-loader>
                        <ngx-skeleton-loader [theme]="{
                            width: '150px',
                            height: '40px'
                          }">
                        </ngx-skeleton-loader>
                    </ng-container>

                    <ng-container *ngIf="!usersLoading">
                        <app-button
                            *ngIf="hasFilters && permissionObj.canFilter"
                            [danger]="true" [outline]="true" class="mr-2"
                            (onClick)="resetForm()">
                            <svg-icon src="assets/images/icon-times.svg"
                                class="filter-clear-icon"></svg-icon>
                            Limpar filtros
                        </app-button>

                        <app-button [inverted]="true" class="add-button mr-2"
                            (onClick)="toggleFilterModal()"
                            *ngIf="permissionObj.canFilter">
                            <svg-icon src="assets/images/icon_filter.svg"
                                class="mr-2"></svg-icon>
                            {{ hasFilters ? 'Editar filtros' : 'Filtrar
                            listagem' }}
                        </app-button>

                        <app-button (onClick)="toggleUserModal()"
                            class="add-button" *ngIf="permissionObj.canAdd">
                            <svg-icon src="assets/images/icon-add.svg"
                                class="mr-2"></svg-icon>
                            Adicionar usuário
                        </app-button>
                    </ng-container>
                </div>
            </div>

            <div class="col-12 mt-3 px-0"
                *ngIf="!usersLoading && hasFilters && appliedFilters.length > 0">
                <div
                    class="d-flex flex-wrap align-items-center justify-content-end">
                    <app-filter-tag *ngFor="let filter of appliedFilters"
                        [label]="filter.label" [value]="filter.value">
                    </app-filter-tag>
                </div>
            </div>

            <ng-container
                *ngIf="!usersLoading && usersData.length === 0 && !hasFilters">
                <app-empty-content [isVisible]="true" [large]="true"
                    [title]="permissionObj.canAdd ? 'Não há nenhum usuário para exibir' : 'Não há nenhum usuário para exibir'"
                    [description]="permissionObj.canAdd ? 'Não há usuários para serem exibidos no momento, para adicionar um novo usuário clique no botão abaixo.' : 'Não há usuários para serem exibidos no momento.'"
                    icon="/assets/images/figure_3d_search.png"
                    (onClick)="permissionObj.canAdd ? toggleUserModal() : null"
                    [haveButtonIcon]="permissionObj.canAdd"
                    [buttonLabel]="permissionObj.canAdd ? 'Adicionar usuário' : null">
                </app-empty-content>
            </ng-container>

            <ng-container
                *ngIf="!usersLoading && usersData.length === 0 && hasFilters">
                <app-empty-content [isVisible]="true" [large]="true"
                    title="Nenhum resultado encontrado"
                    description="Não foram encontrados usuários com os filtros aplicados. Tente ajustar os filtros para ver mais resultados."
                    icon="/assets/images/figure_3d_search.png">
                </app-empty-content>
            </ng-container>
        </div>

        <div class="dash-card-body padding-container">
            <ng-container *ngIf="usersLoading">
                <table #table>
                    <thead>
                        <tr>
                            <th>
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </th>

                            <th>
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </th>

                            <th>
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </th>

                            <th>
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </th>

                            <th>
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </th>

                            <th>
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '100px',
                                        marginBottom:'0'
                                          }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '100px',
                                        marginBottom:'0'
                                          }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '100px',
                                        marginBottom:'0'
                                          }">
                                </ngx-skeleton-loader>
                            </td>
                            <td class="item-number">
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '30px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </td>
                            <td class="item-number">
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '30px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </td>
                            <td class="item-number">
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '30px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>

            <table class="bordered"
                *ngIf="!usersLoading && usersData.length > 0">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Grupos</th>
                        <th>E-mail</th>
                        <th>Departamento</th>
                        <th>Atualização</th>
                        <th>Tipo de usuário</th>
                        <th>status</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of usersData">
                        <td>
                            <div class="dash-card-item-content">
                                <div class="dash-card-item-content-title">
                                    {{item.name}}
                                </div>
                                <div class="dash-card-item-content-subtitle">
                                    {{formatCpf(item.document_number)}}
                                </div>
                            </div>
                        </td>

                        <td>
                            {{formatGroups(item.group)}}
                        </td>

                        <td>
                            {{item.email}}
                        </td>

                        <td>
                            {{item.department}}
                        </td>

                        <td>
                            {{item.updated_at}}
                        </td>

                        <td>
                            {{item.type}}
                        </td>

                        <td>
                            <div class="status-tag"
                                [class.-inactive]="item.status === 'Inativo'">
                                {{item.status}}</div>
                        </td>

                        <td>
                            <div class="dash-card-item-buttons">
                                <button class="dash-item-button"
                                    (click)="redirectToDetails(item.id)"
                                    *ngIf="canViewDetails">
                                    <svg-icon
                                        src="assets/images/icon-eye.svg"></svg-icon>
                                </button>
                                <app-spacer [right]="8"></app-spacer>

                                <button class="dash-item-button"
                                    (click)="toggleUserStatus(item.id)"
                                    *ngIf="permissionObj.canInactive">
                                    <svg-icon
                                        src="assets/images/icon-ban.svg"></svg-icon>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <app-spacer [bottom]="28"></app-spacer>
            </table>
        </div>
    </div>

    <div class="col-12 ml-auto mr-auto"
        *ngIf="!usersLoading && usersData.length > 0">
        <div class="dash-card-pagination">
            <app-pagination [data]="usersData" [count]="usersCount"
                [show]="!usersLoading" [offset]="usersOffset"
                (onPageChange)="changePageData($event, true)"
                [dashPagination]="true" [resultsPerPage]="results_per_page">
            </app-pagination>
        </div>
    </div>

    <app-spacer [bottom]="48" *ngIf="usersLoading"></app-spacer>
</ng-container>
<app-spacer [bottom]="48"></app-spacer>


<!-- <ng-container *ngIf="profilePermissionObj.canView">
    <div class="dash-card no-padding">
        <div class="dash-card-header d-block">
            <ng-container *ngIf="profilesLoading">
                <ngx-skeleton-loader [theme]="{
                            width: '80px',
                            height: '25px'
                          }">
                </ngx-skeleton-loader>
            </ng-container>

            <ng-container
                *ngIf="!profilesLoading && (profilesData.length > 0 || hasFilters)">
                <div style="flex-direction: column;">
                    <div class="row w-100">
                        <div class="col-12">
                            <h2>Perfis de usuários</h2>
                        </div>

                        <div class="col-12 d-flex justify-content-end mt-3">
                            <app-button *ngIf="hasFilters && profilePermissionObj.canFilter"
                                [inverted]="true" class="add-button mr-2"
                                (onClick)="resetForm()">
                                <svg-icon
                                    src="assets/images/carbon-clean.svg"
                                    class="mr-2"></svg-icon>
                                Limpar filtros
                            </app-button>

                            <app-button [inverted]="true" class="add-button mr-2"
                                (onClick)="showProfilesFilterModal = true"
                                *ngIf="profilePermissionObj.canFilter">
                                <svg-icon
                                    src="assets/images/icon_filter.svg"></svg-icon>
                                Aplicar filtros
                            </app-button>

                            <app-button (onClick)="redirectToGroupRegister()"
                                class="add-button" *ngIf="profilePermissionObj.canAdd">
                                <svg-icon src="assets/images/icon-add.svg" class="mr-2"></svg-icon>
                                Vincular perfil de usuários
                            </app-button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

        <ng-container
            *ngIf="!profilesLoading && (profilesData.length === 0 || hasFilters)">
            <app-empty-content [isVisible]="true" [large]="true"
                title="Não há nenhum perfil de usuário para exibir"
                description="Não há perfil de usuários para serem exibidos no momento, para vincular um novo perfil de usuário clique no botão abaixo."
                icon="/assets/images/figure_3d_search.png"
                (onClick)="redirectToGroupRegister()" [haveButtonIcon]="true"
                buttonLabel="Vincular perfil de usuários">
            </app-empty-content>
        </ng-container>

        <div class="dash-card-body padding-container">
            <ng-container *ngIf="profilesLoading">
                <table #table>
                    <thead>
                        <tr>
                            <th>
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </th>

                            <th>
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </th>

                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '100px',
                                        marginBottom:'0'
                                          }">
                                </ngx-skeleton-loader>
                            </td>
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '100px',
                                        marginBottom:'0'
                                          }">
                                </ngx-skeleton-loader>
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>

            <table class="bordered"
                *ngIf="!profilesLoading && (profilesData.length > 0 || hasFilters)">
                <thead>
                    <tr>
                        <th>Perfil</th>
                        <th>Atualização</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of profilesData">
                        <td>
                            {{renderProfileName(item.user_profile)}}
                        </td>

                        <td>
                            {{item.updated_at}}
                        </td>

                        <td>
                            <div class="dash-card-item-buttons">
                                <button class="dash-item-button"
                                    (click)="toggleBond(item.id)"
                                    *ngIf="profilePermissionObj.canUnbound">
                                    <svg-icon
                                        src="assets/images/icon-unlink.svg"></svg-icon>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <app-spacer [bottom]="28"></app-spacer>
            </table>
        </div>
    </div>

    <div class="col-12 ml-auto mr-auto" *ngIf="profilesData.length > 0">
        <div class="dash-card-pagination">
            <app-pagination [data]="profilesData" [count]="profilesCount"
                [show]="!profilesLoading" [offset]="profilesOffset"
                (onPageChange)="changePageData($event)" [dashPagination]="true">
            </app-pagination>
        </div>
    </div>
</ng-container> -->

<app-side-filter-modal [active]="showFilterModal" [formGroup]="filterForm"
    [loading]="usersLoading" title="Filtrar usuários"
    [disableApplyButton]="!canApplyFilters" (onClose)="toggleFilterModal()"
    (onApply)="filterData()" (onReset)="resetForm()">
    <div class="row">
        <div class="col-6">
            <app-input [group]="filterForm" controlName="name"
                placeholder="Digite" label="Nome">
            </app-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-lg-6">
            <app-masked-input [group]="filterForm" controlName="document"
                label="CPF" documentType="cpfOrCnpj" placeholder="Insira seu documento">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-masked-input [group]="filterForm" controlName="start_date"
                mask="00/00/0000" label="Data de início"
                placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-masked-input [group]="filterForm" controlName="end_date"
                mask="00/00/0000" label="Data final" placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
    </div>
</app-side-filter-modal>

<app-side-filter-modal [active]="showProfilesFilterModal"
    [formGroup]="filterForm" [loading]="profilesLoading"
    title="Filtrar perfis de usuários" (onClose)="handleCloseModal()"
    (onApply)="filterData()" (onReset)="resetForm()">
    <div class="row">
        <div class="col-12">
            <app-masked-input [group]="filterForm" controlName="start_date"
                mask="00/00/0000" label="Data de início"
                placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-masked-input [group]="filterForm" controlName="end_date"
                mask="00/00/0000" label="Data final" placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
    </div>
</app-side-filter-modal>

<app-side-modal [active]="showUserModal" title="Adicionar Usuário"
    (onClose)="showUserModal = false">
    <form [formGroup]="form">
        <div class="row">
            <!-- ETAPA 1: Tipo de usuário e CPF -->
            <div class="col-12">
                <p>Tipo de usuário</p>
                <app-spacer [bottom]="16"></app-spacer>

                <div class="d-flex">
                    <app-radio [multiple]="true" [isChecked]="true"
                        [readOnly]="true">
                        <div class="flex-1 d-flex flex-column">
                            <span class="pep-title">Usuário comum</span>
                        </div>
                    </app-radio>
                    <app-spacer [right]="24"></app-spacer>

                    <ng-container>
                        <app-radio [multiple]="true" [isChecked]="false"
                            [disabled]="true">
                            <div class="flex-1 d-flex flex-column">
                                <span class="pep-title"
                                    style="opacity: 0.5;">Usuário master</span>
                            </div>
                        </app-radio>
                    </ng-container>
                </div>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12">
                <app-masked-input [group]="form" controlName="document"
                    label="CPF" mask="000.000.000-00" [isDocument]="true"
                    placeholder="Digite o CPF">
                </app-masked-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <!-- Loading enquanto valida documento -->
            <div class="col-12 text-center" *ngIf="checkingDocument">
                <p style="color: var(--dark); font-size: var(--font-sm);">
                    <svg-icon src="assets/images/icon-loading.svg"></svg-icon>
                    Verificando
                    documento...
                </p>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <!-- ETAPA 2: Resto do formulário (aparece SOMENTE se documentExists === FALSE) -->
            <ng-container *ngIf="!documentExists && !checkingDocument">
                <!-- Campos comuns - APARECEM PRIMEIRO -->
                <div class="col-12">
                    <app-input [group]="form" controlName="name"
                        label="Nome completo" placeholder="Digite">
                    </app-input>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <div class="col-12">
                    <app-input [group]="form" controlName="email" label="E-mail"
                        placeholder="Digite">
                    </app-input>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <!-- Departamento - APARECE DEPOIS (já vem preenchido, readonly) -->
                <div class="col-12">
                    <app-select [items]="departmentOptions" [group]="form"
                        controlName="department"
                        [placeholder]="loadingDepartments ? 'Carregando departamentos...' : 'Selecione'"
                        [readOnly]="true" label="Departamento">
                    </app-select>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>

                <div class="col-12">
                    <app-select [items]="profileOptions" [group]="form"
                        controlName="profile"
                        [placeholder]="loadingProfiles ? 'Carregando perfis...' : (!form.value.department ? 'Primeiro selecione o departamento' : 'Selecione')"
                        [readOnly]="!form.value.department || loadingProfiles"
                        label="Perfil de acesso">
                    </app-select>
                    <app-spacer [bottom]="16"></app-spacer>
                </div>
            </ng-container>

        </div>

        <!-- Loading Spinner ao carregar perfis de departamento -->
        <app-loading-spinner [active]="loadingProfiles"></app-loading-spinner>

        <app-spacer [bottom]="64"></app-spacer>

        <div class="row button-sticky">
            <div class="col-12 col-lg-6">
                <app-button (onClick)="handleCloseModal()" class="add-button"
                    [phantom]="true">
                    Cancelar
                </app-button>
            </div>

            <div class="col-12 col-lg-6">
                <div class="text-right">
                    <app-button (onClick)="submit()" [disabled]="getDisabled()"
                        class="add-button" [loading]="submiting">
                        Adicionar usuário
                    </app-button>
                </div>
            </div>
        </div>
    </form>
</app-side-modal>

<!-- Carbon Warning Modals -->
<app-carbon-warning-modal [active]="showBondModal" [title]="getBondModalTitle()"
    [message]="getBondModalMessage()" [confirmText]="getBondConfirmText()"
    [cancelText]="'Não, manter como está'"
    [confirmAction]="confirmBondRemoval.bind(this)"
    [cancelAction]="closeBondModal.bind(this)" (onClose)="closeBondModal()">
</app-carbon-warning-modal>

<app-carbon-warning-modal [active]="showStatusModal"
    [title]="getStatusModalTitle()" [message]="getStatusModalMessage()"
    [confirmText]="getStatusConfirmText()"
    [cancelText]="'Não, manter como está'"
    [confirmAction]="confirmStatusChange.bind(this)"
    [cancelAction]="closeStatusModal.bind(this)" (onClose)="closeStatusModal()">
</app-carbon-warning-modal>

<app-carbon-warning-modal [active]="showProfileStatusModal"
    [title]="getProfileStatusModalTitle()"
    [message]="getProfileStatusModalMessage()"
    [confirmText]="getProfileStatusConfirmText()"
    [cancelText]="'Não, manter como está'"
    [confirmAction]="confirmProfileStatusChange.bind(this)"
    [cancelAction]="closeProfileStatusModal.bind(this)"
    (onClose)="closeProfileStatusModal()">
</app-carbon-warning-modal>

<app-carbon-warning-modal [active]="showUserStatusModal"
    [title]="getUserStatusModalTitle()" [message]="getUserStatusModalMessage()"
    [confirmText]="getUserStatusConfirmText()"
    [cancelText]="'Não, manter como está'"
    [confirmAction]="confirmUserStatusChange.bind(this)"
    [cancelAction]="closeUserStatusModal.bind(this)"
    (onClose)="closeUserStatusModal()">
</app-carbon-warning-modal>